import { combineReducers } from '@reduxjs/toolkit';
import userReducer from '@/redux/project/ProjectSlice';
import orderReducer from '@/redux/order/orderSlice';
import productReducer from '@/redux/product/productSlice';
import categoryReducer from '@/redux/categories/categorySlice';
import invoiceReducer from '@/redux/Invoice/InvoiceSlice';
import SubCategory from '@/redux/SubCategory/SubCategorySlice';
import customer from '@/redux/customers/CustomerSlice';
import refund from '@/redux/refunds/RefundSlice';
import banner from '@/redux/Banner/BannerSlice';
import community from '@/redux/Community/communityslice';
import storyProductSlice from '@/redux/StoryProduct/storyproduct';
import attribute from '@/redux/attributes/AttributeSlice';
import coupon from '@/redux/coupons/CouponSlice';
import wholesalerReducer from '@/redux/wholesaler/WholesalerSlice';
import logoReducer from '@/redux/logo/LogoSlice';
import cartReducer from '@/redux/cart/cartSlice';
import pageSectionReducer from '@/redux/pageSection/pageSlice';
import deliveryManReducer from '@/redux/deliveryMan/DeliverySlice';
import resellerReducer from '@/redux/reseller/ResellerSlice';
import employeeRedure from '@/redux/employees/EmployeesSlice';
import themeReducer from '@/redux/Theme/ThemeSlice';
import locationSlice from './country/locationSlice';
import socialMediaSlice from '@/redux/socialMedia/SocialMediaSlice';
import brandReducer from '@/redux/brand/BrandSlice';
import blogReducer from '@/redux/blog/BlogSlice';
import unitReducer from '@/redux/unit/UnitSlice';
import testimonialReducer from '@/redux/testimonial/testimonialSlice';
import paymentGatewayReducer from '@/redux/paymentGateway/PaymentGatewaySlice';
import subscriptionPlanReducer from '@/redux/subscriptionPlan/subscriptionPlanSlice';
import walletReducer from '@/redux/wallet/WalletSlice';
import beneficiaryReducer from '@/redux/beneficiary/beneficiarySlice';
import businessCategoryReducer from '@/redux/businessCategory/BusinessCategorySlice';
import { businessCategory } from '@/services/api/cresivoxServer';
import shiprocketReducer from '@/redux/Shiprocket/ShiprocketSlice';
import pluginSlice from './plugnin/PluginSlice';
import { clearShippingState } from './calculateShippingCharge/calculateSlice';
import liveSaleSlice from '@/redux/LiveSale/liveSaleSlice';
import featuredDealReducer from '@/redux/FeaturedSale/FeaturedSaleSlice';
import dealOfTheDayReducer from '@/redux/DealoftheDay/DealoftheDaySlice';
import poSlice from '@/redux/POSection/poSlice';
import polistSlice from '@/redux/PoListSection/polistSlice';
import addbillingSlice from '@/redux/addBilllingDetails/addbillingSlice';
import getbillingSlice from '@/redux/getBillingDetails/getbillingSlice';
import purchaseOrderSlice from '@/redux/purchaseOrderDetails/purchaseOrderSlice';
import clearAdminRechargedValletState from './adminRecharged/RechrgedSlice';
import proFormaStateReducer from '@/redux/proFormaInvoice/ProFormSlice';
import productReportDetail from '@/redux/productReportData/productSlice';
import orderReportDetail from '@/redux/orderReportData/orderSlice';
import saleReportDetail from '@/redux/saleReportData/saleDataSlice';
import getThemeList from '@/redux/addThemeReachage/addThemeSlice';
import adminThemeList from '@/redux/adminSaleTheme/adminSlice';
import userThemeList from '@/redux/userThemeInstalles/userSlice';
import projectList from '@/redux/zipUpload/zipUploadSlice';
import facebookAccountReducer from '@/redux/facebookAccount/FacebookAccountSlice';
import fbCampaignSlice from '@/redux/fbCampaign/fbCampaignSlice';
import fbAdsSlice from '@/redux/fbAds/fbAdsSlice';
import fbAdsetSlice from '@/redux/fbAdset/fbAdsetSlice';
import fbCreativeSlice from '@/redux/fbCreative/fbCreativeSlice';
import facebookLeadsReducer from '@/redux/facebookLeads/facebookLeadsSlice';
import ticketsReducer from '@/redux/tickets/ticketsSlice';
import crmReducer from '@/redux/crm/crmSlice';
import employeeKpiReducer from '@/redux/employeeKpi/employeeKpiSlice';
import verifyWholesalerReducer from '@/redux/verifyWholesaler/verifyWholesalerSlice';
import commission from '@/redux/Commission/CommissionSlice';
import vendorsService from '@/redux/vendorProducts/VendorsSlice';
import vendorsRedure from '@/redux/vendors/VendorsSlice';
import instagramAccountReducer from '@/redux/instagramAccount/InstagramAccountSlice';
import instaCampaignSlice from '@/redux/instaCampaign/instaCampaignSlice';
import instaAdsetSlice from '@/redux/instaAdset/instagramAdsetSlice';
import instaCreativeSlice from '@/redux/instaCreative/instagramCreativeSlice';
import instaAdsSlice from '@/redux/instaAds/instagramAdsSlice';
import productSearch from '@/redux/productSearch/ProductSearchSlice';
import vibemartThemeReducer from '@/redux/vibemartTheme/vibemartSlice';
import lockAmountReducer from '@/redux/addLocker/addLockerSlice';
import importReseller from '@/redux/adminBulkImport/importSlice';
import meta from '@/redux/Meta/MetaSlice';
import importResellerSlice from '@/redux/resellerSubscription/SubscriptionSlice';
import employeeOrderSlice from '@/redux/employeeOrder/employeeOrderSlice';
import domainDetailSlice from '@/redux/vendorDomain/vendorDomainSlice';
import appListReducer from '@/redux/appList/appListSlice';
import setupReducer from "./setupSlice";
import deletedUsersReducer from './deletedUsers/Slice';
import enquiryReducer from '@/redux/enquiry/EnquirySlice';
import wholesalerBrandingReducer from '@/redux/wholesalerBranding/wholesalerBrandingSlice';

// Combine multiple reducers into a single root reducer
const rootReducer = combineReducers({
  user: userReducer,
  orderById: orderReducer,
  product: productReducer,
  category: categoryReducer,
  invoice: invoiceReducer,
  subCategory: SubCategory,
  customer: customer,
  refund: refund,
  banner: banner,
  community: community,
  storyproduct: storyProductSlice,
  attribute: attribute,
  coupon: coupon,
  wholersaler: wholesalerReducer,
  logo: logoReducer,
  cart: cartReducer,
  pageSection: pageSectionReducer,
  delivery: deliveryManReducer,
  reseller: resellerReducer,
  employees: employeeRedure,
  theme: themeReducer,
  location: locationSlice,
  socialMedia: socialMediaSlice,
  brand: brandReducer,
  blogs: blogReducer,
  unit: unitReducer,
  testimonial: testimonialReducer,
  paymentGateway: paymentGatewayReducer,
  shiprocket: shiprocketReducer,
  subscriptionPlan: subscriptionPlanReducer,
  wallet: walletReducer,
  beneficiary: beneficiaryReducer,
  businessCategory: businessCategoryReducer,
  plugin: pluginSlice,
  calculateCharged: clearShippingState,
  liveSale: liveSaleSlice,
  featuredDeal: featuredDealReducer,
  dealOfTheDay: dealOfTheDayReducer,
  poSlice: poSlice,
  polistSlice: polistSlice,
  addbillingSlice: addbillingSlice,
  getbillingSlice: getbillingSlice,
  purchaseOrderSlice: purchaseOrderSlice,
  adminRechargedVallet: clearAdminRechargedValletState,
  proFormaState: proFormaStateReducer,
  productDetail: productReportDetail,
  orderDetail: orderReportDetail,
  saleDetail: saleReportDetail,
  themeList: getThemeList,
  adminTheme: adminThemeList,
  userTheme: userThemeList,
  zipProjectList: projectList,
  facebookAccountList: facebookAccountReducer,
  fbCampaignList: fbCampaignSlice,
  fbAdsList: fbAdsSlice,
  fbAdsetList: fbAdsetSlice,
  fbCreativeList: fbCreativeSlice,
  facebookLeads: facebookLeadsReducer,
  tickets: ticketsReducer,
  crm: crmReducer,
  verifyWholesaler: verifyWholesalerReducer,
  commission: commission,
  vendorProductsList: vendorsService,
  vendorsList: vendorsRedure,
  instagramAccountList: instagramAccountReducer,
  instaCampaignList: instaCampaignSlice,
  instaAdsetList: instaAdsetSlice,
  instaCreativeList: instaCreativeSlice,
  instaAdsList: instaAdsSlice,
  productSearch: productSearch,
  vibemartTheme: vibemartThemeReducer,
  lockAmount: lockAmountReducer,
  adminBulkImportData: importReseller,
  meta: meta,
  resellerData: importResellerSlice,
  employeesData: employeeOrderSlice,
  domainDetail: domainDetailSlice,
  appList: appListReducer,
  setup: setupReducer,
  deletedUsers: deletedUsersReducer,
enquiry: enquiryReducer,
  wholesalerBranding: wholesalerBrandingReducer,
  employeeKpi: employeeKpiReducer,
});
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
